import { render, staticRenderFns } from "./RangeValidationForm.vue?vue&type=template&id=52b71286&scoped=true"
import script from "./RangeValidationForm.vue?vue&type=script&lang=js"
export * from "./RangeValidationForm.vue?vue&type=script&lang=js"
import style0 from "./RangeValidationForm.vue?vue&type=style&index=0&id=52b71286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b71286",
  null
  
)

export default component.exports